import type {ReactElement} from 'react';
import {useEffect, useState} from 'react';
import React from 'react';
import {useAppDispatch, useAppSelector} from '@/hooks';
import {EditorMobileOnboardingStatus, endOnboarding} from '@Components/poster-editor/components/editor-mobile-onboarding/editor-mobile-onboarding.reducer';
import {AnimatePresence, motion} from 'framer-motion';
import {Tooltip, TOOLTIP_POSITION} from '@Components/tooltip';
import {Text, TextSize} from '@Components/text';
import styles from './timeline-mobile-onboarding.module.scss';
import {showTimelineOnBoarding, toggleTimelineOnBoardingToSeen} from '@Components/poster-editor/library/poster-editor-library';

export function TimelineMobileOnboarding(): ReactElement<any> {
  const onBoardingStatus = useAppSelector((state) => {
    return state.editorMobileOnboarding.onBoardingStatus;
  });
  const [showTooltip, setShowTooltip] = useState(false);
  const dispatch = useAppDispatch();

  useEffect((): void => {
    if (onBoardingStatus === EditorMobileOnboardingStatus.TIMELINE_MOBILE) {
      startTimelineOnboarding();
    }
  }, [onBoardingStatus]);

  const startTimelineOnboarding = (): void => {
    if (!showTimelineOnBoarding()) {
      dispatch(endOnboarding());
      return;
    }
    setShowTooltip(true);

    setTimeout((): void => {
      setShowTooltip(false);
      dispatch(endOnboarding());
      toggleTimelineOnBoardingToSeen();
    }, 5200);
  };

  return (
    <AnimatePresence>
      {showTooltip ? (
        <motion.div initial={{opacity: 0}} animate={{opacity: 1}} transition={{duration: 0.1}} exit={{opacity: 0}}>
          <Tooltip
            style={{
              position: 'fixed',
              left: `22px`,
              bottom: `86px`,
            }}
            className={`${styles.tooltip} radius-8`}
            position={TOOLTIP_POSITION.BOTTOM_LEFT}
            id="add-item-tooltip"
            text={
              <div className="flex-v-row">
                <div className={`flex-h-row ${styles.headerMargin}`}>
                  <Text className={styles.newText} val={window.i18next.t('pmwjs_new')} size={TextSize.XSMALL} />
                  <Text className="spacing-m-l-1" bold val={`· ${window.i18next.t('pmwjs_timeline_onboarding_mobile_header_text')}`} size={TextSize.XSMALL} />
                </div>
                <Text className="-text-align-left" dangerouslySetInnerHTML size={TextSize.XXSMALL} val={window.i18next.t('pmwjs_timeline_onboarding_text_mobile')} />
              </div>
            }
          />
        </motion.div>
      ) : null}
    </AnimatePresence>
  );
}
